import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7e201b5e")

_pushScopeId("data-v-7e201b5e")
const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex flex-row mt-6 w-full mb-8" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "flex flex-row mb-8" }
const _hoisted_7 = { class: "flex flex-row w-full mb-8" }
const _hoisted_8 = { class: "flex flex-row mb-8 w-full" }
const _hoisted_9 = { class: "text-sm font-semibold text-gray-lp-300 mb-2" }
const _hoisted_10 = { class: "text-xs text-gray-lp-800 mb-2" }
const _hoisted_11 = { class: "border border-gray-lp-200 rounded-lg p-3 text-sm text-gray-lp-300" }
const _hoisted_12 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_13 = { class: "flex w-full flex-row justify-start" }
const _hoisted_14 = { class: "font-semibold flex flex-row justify-end w-full" }
const _hoisted_15 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_16 = { class: "flex w-full flex-row justify-start" }
const _hoisted_17 = { class: "font-semibold flex flex-row justify-end w-full text-right" }
const _hoisted_18 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_19 = { class: "flex w-full flex-row justify-start" }
const _hoisted_20 = { class: "font-semibold flex flex-row justify-end w-2/3" }
const _hoisted_21 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_22 = { class: "flex w-full flex-row justify-start" }
const _hoisted_23 = { class: "font-semibold flex flex-row justify-end w-full text-right" }
const _hoisted_24 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_25 = { class: "flex w-full flex-row justify-start" }
const _hoisted_26 = { class: "font-semibold flex flex-row justify-end w-full" }
const _hoisted_27 = { class: "w-36" }
const _hoisted_28 = { class: "w-full flex flex-row items-center" }
const _hoisted_29 = { class: "w-36" }
const _hoisted_30 = { class: "w-full flex flex-row items-center" }
const _hoisted_31 = { class: "w-36 mr-4" }
const _hoisted_32 = { class: "w-36" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_PickupCorporateAddressSection = _resolveComponent("PickupCorporateAddressSection")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_MultipleSelectProduct = _resolveComponent("MultipleSelectProduct")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TimeRangePickerV2 = _resolveComponent("TimeRangePickerV2")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_SavedAddressList = _resolveComponent("SavedAddressList")!
  const _component_ModalAddNewAddress = _resolveComponent("ModalAddNewAddress")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    "on-back": _ctx.onBack,
    title: _ctx.$t('pickupCorporate.titleCreate'),
    "vertical-separator": false,
    loading: _ctx.apiDetailData.loading,
    error: !!_ctx.apiDetailData.errorType,
    "error-type": _ctx.apiDetailData.errorType
  }, {
    "top-right": _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_button_fill, {
          title: _ctx.$t('pickupCorporate.save'),
          class: "bg-red-lp-300 px-8",
          "is-disabled": !_ctx.isFormValid || _ctx.isLoadingSubmit,
          onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.onSubmit();
            }
          )
        }, null, 8, ["title", "is-disabled"])
      ])
    ]),
    data: _withId(() => [
      _createVNode("main", _hoisted_2, [
        _createVNode("section", _hoisted_3, [
          _createVNode(_component_Title, {
            label: _ctx.$t('pickupCorporate.detailInfo')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              class: "w-full mr-4",
              label: _ctx.$t('pickupCorporate.clientRef'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectSearch, {
                  class: ["mt-1.5 h-10 client-ref", [{ disabled: _ctx.isClientBranch }]],
                  options: _ctx.clientOptions,
                  modelValue: _ctx.form.clientId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.clientId = $event)),
                  "is-server-side": true,
                  "is-loading": _ctx.clientController.isLoading,
                  "key-value": 'name',
                  placeholder: _ctx.$t('pickupCorporate.placeholderClient'),
                  "is-disabled": _ctx.isClientBranch,
                  onFilter: _ctx.onSearchClient,
                  onChange: _ctx.onSelectClient
                }, null, 8, ["class", "options", "modelValue", "is-loading", "placeholder", "is-disabled", "onFilter", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              label: _ctx.$t('pickupCorporate.the3lcPickUp'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_Select, {
                  class: "mt-1.5 lettercode-select",
                  "custom-class": "mr-0",
                  "data-select": _ctx.letterCodeOptions,
                  value: _ctx.form.cityId,
                  isDisabled: true
                }, null, 8, ["data-select", "value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode(_component_PickupCorporateAddressSection, {
            ref: "PickupCorporateAddressSection",
            "is-internal": _ctx.isAdmin,
            onOnAddressListUpdated: _ctx.onAddressListUpdated,
            onOnClickPilihAlamatLain: _ctx.onClickPilihAlamatLain,
            onOnClickTambahAlamat: _ctx.onClickTambahAlamat
          }, null, 8, ["is-internal", "onOnAddressListUpdated", "onOnClickPilihAlamatLain", "onOnClickTambahAlamat"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('pickupCorporate.courierNote'),
            class: "mb-8",
            optional: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.form.courierNote,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.courierNote = $event)),
                placeholder: _ctx.$t('pickupCorporate.placeholderCourierNote'),
                type: "textarea",
                "text-area-rows": "3",
                "max-length": 255,
                "show-max-length": ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("section", _hoisted_5, [
          _createVNode(_component_Title, {
            label: _ctx.$t('pickupCorporate.fleetAndSchedule'),
            class: "mb-8"
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DataWrapper, {
              class: "mr-4",
              label: _ctx.$t('pickupCorporate.vehicleType'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_Select, {
                  class: "mt-2",
                  "data-select": _ctx.transportTypeOptions,
                  value: _ctx.form.transportType,
                  "is-open-menu": _ctx.isTransportTypeSelectOpen,
                  "on-open-select": 
                  () => {
                    _ctx.isTransportTypeSelectOpen = true;
                  }
                ,
                  "on-close-select": 
                  () => {
                    _ctx.isTransportTypeSelectOpen = false;
                  }
                ,
                  "on-choose-select": 
                  (_name, val) => {
                    _ctx.form.transportType = val;
                  }
                
                }, null, 8, ["data-select", "value", "is-open-menu", "on-open-select", "on-close-select", "on-choose-select"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.serviceType'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_MultipleSelectProduct, {
                  class: "mt-2",
                  modelValue: _ctx.form.serviceCode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.serviceCode = $event)),
                  status: "active",
                  disabledJumboPackH2h: "true",
                  placeholder: _ctx.$t('pickupCorporate.placeholderService')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_DataWrapper, {
              class: "mr-6",
              label: _ctx.$t('pickupCorporate.estimateTonase'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.estimateTotalTonase,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.estimateTotalTonase = $event)),
                  placeholder: _ctx.$t('pickupCorporate.placeholderEstimateTonase'),
                  suffix: "kg",
                  type: "number"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.estimateKoli'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.estimateTotalKoli,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.estimateTotalKoli = $event)),
                  placeholder: _ctx.$t('pickupCorporate.placeholderEstimateKoli'),
                  type: "number"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_DataWrapper, {
              class: "mr-6",
              label: _ctx.$t('pickupCorporate.datePickUp'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_DatePicker, {
                  class: "mt-2",
                  modelValue: _ctx.form.pickupDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.pickupDate = $event)),
                  "min-date": _ctx.minDate,
                  placeholder: _ctx.$t('pickupCorporate.selecDate')
                }, null, 8, ["modelValue", "min-date", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.timePickUp'),
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_TimeRangePickerV2, {
                  class: "mt-2",
                  modelValue: _ctx.form.time,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.time = $event)),
                  titlePickup: _ctx.$t('Pilih jam Pick Up'),
                  placeholder: _ctx.$t('pickupCorporate.placeholderTime')
                }, null, 8, ["modelValue", "titlePickup", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        (_ctx.showModalSuccess)
          ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 0 }, _ctx.modalMessageEntities, { "custom-width": "430px" }), {
              custom: _withId(() => [
                _createVNode("section", null, [
                  _createVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t("pickupCorporate.modalSuccessTitle")), 1),
                  _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("pickupCorporate.modalSuccessMessage", { shipmentId: _ctx.shipmentId })), 1)
                ]),
                _createVNode("section", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("pickupCorporate.transportType")), 1),
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.pickupSuccessModalData.transportType), 1)
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("pickupCorporate.serviceType")), 1),
                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.pickupSuccessModalData.serviceCodes), 1)
                  ]),
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("pickupCorporate.pickupDate")), 1),
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.pickupSuccessModalData.pickupDate), 1)
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("pickupCorporate.pickupDay")), 1),
                    _createVNode("div", _hoisted_23, _toDisplayString(_ctx.pickupSuccessModalData.pickupDay), 1)
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("pickupCorporate.jamPickup")), 1),
                    _createVNode("div", _hoisted_26, _toDisplayString(_ctx.pickupSuccessModalData.timePickup), 1)
                  ])
                ])
              ]),
              "custom-button": _withId(() => [
                _createVNode("div", _hoisted_27, [
                  _createVNode(_component_lp_button, {
                    class: "text-white",
                    "is-width-full": "",
                    "font-bold": "",
                    title: _ctx.$t('pickupCorporate.ok'),
                    onClick: _ctx.onCloseModalSucces
                  }, null, 8, ["title", "onClick"])
                ])
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true),
        (_ctx.showModalFailed)
          ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 1 }, _ctx.modalErrorMessageEntities), {
              "custom-button": _withId(() => [
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode(_component_lp_button, {
                      class: "text-white",
                      "is-width-full": "",
                      "font-bold": "",
                      title: _ctx.$t('pickupCorporate.ok'),
                      onClick: _cache[9] || (_cache[9] = 
                    () => {
                      _ctx.showModalFailed = false;
                      _ctx.isErrorPickupTime = false;
                    }
                  )
                    }, null, 8, ["title"])
                  ])
                ])
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true),
        (_ctx.showModalConfirm)
          ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 2 }, _ctx.modalConfirmEntities), {
              "custom-button": _withId(() => [
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _createVNode(_component_button_outline, {
                      "is-width-full": "",
                      "font-bold": "",
                      title: _ctx.$t('pickupCorporate.back'),
                      onClick: _cache[10] || (_cache[10] = 
                    () => {
                      _ctx.showModalConfirm = false;
                    }
                  )
                    }, null, 8, ["title"])
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _createVNode(_component_lp_button, {
                      class: "text-white",
                      "is-width-full": "",
                      "font-bold": "",
                      title: _ctx.$t('pickupCorporate.save'),
                      onClick: _ctx.onSubmit
                    }, null, 8, ["title", "onClick"])
                  ])
                ])
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true),
        (_ctx.isSavedAddressListOpen)
          ? (_openBlock(), _createBlock(_component_SavedAddressList, {
              key: 3,
              isShown: _ctx.isSavedAddressListOpen,
              "onUpdate:isShown": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isSavedAddressListOpen = $event)),
              onSelectAddress: _ctx.onSelectAddress,
              onUpdateDefaultAddress: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateListPickupCorporateAddress(false))),
              onAddressDeleted: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateListPickupCorporateAddress(true))),
              clientId: Number(_ctx.form.clientId.value),
              selectedAddress: _ctx.selectedAddress
            }, null, 8, ["isShown", "onSelectAddress", "clientId", "selectedAddress"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_ModalAddNewAddress, {
          formType: "add",
          isVisible: _ctx.isAddAddressOpen,
          onClose: _ctx.onClickTambahAlamat,
          onOnSuccess: _ctx.onSuccessTambahAlamat,
          clientId: Number(_ctx.form.clientId.value),
          forceDefault: true
        }, null, 8, ["isVisible", "onClose", "onOnSuccess", "clientId"]), [
          [_vShow, _ctx.isAddAddressOpen]
        ])
      ])
    ]),
    _: 1
  }, 8, ["on-back", "title", "loading", "error", "error-type"]))
})